import html2canvas from "html2canvas";

const handleDownload = async (idOfTheItem: string) => {
  const element = document.getElementById(idOfTheItem);
  if (!element) return;

  const canvas = await html2canvas(element as HTMLElement, {
    backgroundColor: null,
    useCORS: true,
  });

  const pngUrl = canvas.toDataURL("image/png");
  const downloadLink = document.createElement("a");
  downloadLink.href = pngUrl;
  downloadLink.download = "qr-code.png";
  downloadLink.click();
};

export default handleDownload;
